module.exports = __webpack_public_path__ + "img/kantar_art_white_logo.c469a16c.png";